<template lang="pug">
#members-tab
  spinner(v-if="settings.loading")
  div(v-else)
    b-table(
      :data="members"
      :total="pagination.total"
      :current-page="pagination.page"
      :per-page="pagination.per"
      @click="open"
      @page-change="getPage"
      hoverable
      paginated
      backend-pagination
    )
      template(slot-scope="props")
        b-table-column(label="Name") {{ props.row.name }}
        b-table-column(label="Phone Number")
          small.phone-number
            span {{ props.row.phone_number | phoneNumber }}
            b-icon.has-text-success(
              v-if="props.row.is_verified"
              icon="check-circle"
              size="is-small"
            )
        b-table-column(label="Created")
          small {{ props.row.created_at | date }} at {{ props.row.created_at | date('hh:mm A') }}
        b-table-column(label="Approval Status")
          b-tag(:type="props.row.is_approved ? 'is-success' : 'is-danger'") {{ props.row.is_approved ? 'Yes' : 'No' }}
        b-table-column(label="Approval Method")
          small(v-if="props.row.is_approved && props.row.approval_method") {{ props.row.approval_method | capitalize }}
          small.has-text-grey-light(v-else) NA
        b-table-column(label="Approved")
          small(v-if="props.row.is_approved && props.row.approved_at") {{ props.row.approved_at | date }} at {{ props.row.approved_at | date('hh:mm A') }}
          small.has-text-grey-light(v-else) NA
</template>

<script>
import { mapGetters } from 'vuex';
import MemberForm from '@/components/form/MemberForm';
import Spinner from '@/components/Spinner';
import * as actions from '@/store/types/actions';
import * as getters from '@/store/types/getters';

export default {
  name: 'members-tab',
  components: {
    Spinner,
  },
  computed: {
    ...mapGetters({
      account: getters.GET_ACCOUNT,
      filters: getters.GET_MINISTRY_FILTERS,
      members: getters.GET_MEMBERS,
      refresh: getters.GET_MINISTRY_REFRESH,
    }),
    esQuery() {
      const from = this.pagination.per * (this.pagination.page - 1);
      const payload = {
        aggs: {
          not_approved: {
            filter: {
              bool: {
                must: [
                  { match: { account_id: this.account.id } },
                  { match: { is_approved: false } },
                ],
              },
            },
          },
        },
        from,
        size: this.pagination.per,
        sort: [
          { created_at: 'desc' },
        ],
        query: {
          bool: {
            must: [
              { match: { account_id: this.account.id } },
            ],
          },
        },
      };
      if (this.filters.approved !== 'all') {
        payload.query.bool.must.push({ match: { is_approved: this.filters.approved } });
      }
      if (this.filters.query) {
        payload.query.bool.must.push({ match_phrase_prefix: { name: this.filters.query } });
      }
      return payload;
    },
  },
  created() {
    this.getPage(1);
  },
  data() {
    return {
      pagination: {
        page: 1,
        per: 26,
        total: 0,
      },
      settings: {
        loading: false,
      },
    };
  },
  methods: {
    async getPage(page) {
      this.settings.loading = true;
      this.pagination.page = page;
      const response = await this.$store.dispatch(actions.DO_SEARCH_MEMBERS, this.esQuery);
      this.pagination.total = response.hits.total;
      this.settings.loading = false;
    },
    async open(member) {
      await this.$store.dispatch(actions.DO_GET_MEMBER, {
        id: member.id,
      });
      this.$buefy.modal.open({
        parent: this,
        component: MemberForm,
        hasModalCard: true,
      });
    },
  },
  watch: {
    refresh(val) {
      if (val) this.getPage(1);
    },
  },
};
</script>

<style lang="scss">
#members-tab {
  .phone-number {
    .icon {
      margin-left: 0.25rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MembersTab.vue